import {css} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {Alignment} from '@fo/shared-types';
import {Size} from './types';

const getAlignment = (alignment: Alignment): string => {
  switch (alignment) {
    case Alignment.CENTER:
      return 'center';
    case Alignment.RIGHT:
      return 'flex-end';
    case Alignment.LEFT:
    default:
      return 'flex-start';
  }
};

const getSizeCSS = (size: Size): string => {
  const sizeSmall = '6.4rem';
  const sizeMedium = '12.8rem';
  const sizeLarge = '25.6rem';

  switch (size) {
    case Size.SMALL:
      return `
        width: ${sizeSmall};
        max-height: ${sizeSmall};
      `;
    case Size.LARGE:
      return `
        width: ${sizeLarge};
        max-height: ${sizeLarge};
      `;
    case Size.MEDIUM:
    default:
      return `
        width: ${sizeMedium};
        max-height: ${sizeMedium};
      `;
  }
};

export default {
  container: (alignment: Alignment, isBottomPadding?: boolean): string => css`
    label: bankingPartnerSection;
    display: flex;
    align-items: center;
    ${!isBottomPadding
      ? css`
          padding-top: ${spacing.M};
          padding-bottom: ${spacing.M};
        `
      : ''}
    margin: 0 auto;
    justify-content: ${getAlignment(alignment)};
    ${mq(Breakpoints.TABLET)} {
      margin: 0;
    }
  `,
  logoLink: css`
    label: bankingPartnerSection__logoLink;
    display: flex;
    margin-right: 0;
    ${mq(Breakpoints.TABLET)} {
      margin-right: ${spacing.XS};
    }
  `,
  logo: (size: Size): string => css`
    label: bankingPartnerSection__logo;
    ${getSizeCSS(size)};
  `,
  logoImg: css`
    label: bankingPartnerSection__logoImg;
    width: 100%;
  `,
  endorsedByText: css`
    label: bankingPartnerSection__endorsedByText;
    margin-right: ${spacing.XXS};
    color: ${colours.font.ASSISTIVE};
  `,
  text: css`
    label: bankingPartnerSection__text;
    display: none;
    color: ${colours.font.ASSISTIVE};

    ${mq(Breakpoints.TABLET)} {
      display: block;
    }
  `,
};
